import { WSFilterValue } from "@wingspanhq/fe-component-library";
import { PayrollRunStatus } from "@wingspanhq/wingspan-api-sdk";

import { PAYROLL_RUNS_STATUS_FILTER_OPTIONS } from "../constants";

/**
 * Expands the display statuses picked in the history filter into the v3
 * `PayrollRunStatus` values to send as `filter[status][anyOf]`.
 *
 * Takes the raw `WSFilterValue` off the URL query rather than `string[]`: the
 * checkbox filter round-trips as an array, but a hand-written
 * `?filter[status]=Opened` parses back as a bare string, and the date/amount
 * range shapes share the same value union. Anything that isn't a status label
 * is ignored.
 *
 * Returns `undefined` when nothing (or nothing recognised) is selected, so the
 * caller can omit the filter entirely instead of sending an empty `anyOf`.
 */
export const selectorPayrollRunsFilterStatuses = (
  selectedLabels?: WSFilterValue
): PayrollRunStatus[] | undefined => {
  const labels = Array.isArray(selectedLabels)
    ? selectedLabels
    : typeof selectedLabels === "string"
      ? [selectedLabels]
      : [];

  if (labels.length === 0) {
    return undefined;
  }

  const statuses = PAYROLL_RUNS_STATUS_FILTER_OPTIONS.filter(option =>
    labels.includes(option.label)
  ).flatMap(option => option.statuses);

  return statuses.length > 0 ? statuses : undefined;
};
